import { render } from "./404.vue?vue&type=template&id=09ad8bb2&scoped=true"
const script = {}

import "./404.vue?vue&type=style&index=0&id=09ad8bb2&lang=scss&scoped=true"

import exportComponent from "D:\\workspace\\Yuegao\\vue_pro\\2003_yuebao_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09ad8bb2"]])

export default __exports__